<template>

    <div v-click-outside="hide" class="cp-dropdown" :class="{ active: show }">
        <a href="#" class="cp-dropdown-toggle" @click.prevent="show = !show">
            <span class="mr-6">{{ title }}</span><v-arrow class="mb-2" />
        </a>
        <transition name="dropdown">
            <div v-if="show" class="cp-dropdown-menu">
                <div class="content">
                    <div @click="show = false">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>

<style lang="scss">

    .cp-dropdown {

        position: relative;

        &.active .cp-dropdown-toggle {
            color: $color-link-hover;
        }

        .cp-dropdown-toggle {
            @include font-semibold(12px);
            color: $color-text;
            line-height: 40px;
            padding: 0 10px;
            text-decoration: none;
            &:hover {
                color: $color-link-hover;
            }
        }

        .cp-dropdown-menu {
            position: relative;
            .content {
                background: #fff;
                border: 1px solid $color-rule;
                border-radius: 3px;
                left: 50%;
                margin-left: -100px;
                padding: 10px 0;
                position: absolute;
                width: 200px;
            }
            a {
                @include font-medium(13px);
                display: block;
                padding: 3px 15px;
            }
        }

        .cp-dropdown-menu:before,
        .cp-dropdown-menu:after {
            content: '';
            border-bottom: 8px solid;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            height: 0;
            left: 50%;
            margin-left: -8px;
            position: absolute;
            width: 0;
        }
        .cp-dropdown-menu:before {
            border-bottom-color: $color-rule;
            top: -8px;
        }
        .cp-dropdown-menu:after {
            border-bottom-color: #fff;
            top: -6px;
        }

    }

</style>

<script>

import ClickOutside from 'vue-click-outside';

export default {

    directives: {
        ClickOutside,
    },

    props: {
        title: {
            type: String,
            default: 'Menu',
        },
        toggleClass: {
            type: String,
        },
    },

    data() {
        return {
            show: false,
        }
    },

    methods: {

        hide() {
            this.show = false;
        },

    },

}

</script>